import externalBlocStore from "./externalBlocStore";
import useBloc from "./useBloc";
const useBlocNext = useBloc;

export type { BlocHookOptions } from "./useBloc";
export { externalBlocStore, useBloc, useBlocNext };
